import styled from 'styled-components';

import type { CompanyData } from '@xing-com/crate-jobs-helpers';
import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { NotOnSmall, OnlyOnSmall } from '@xing-com/layout-primitives';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceL, spaceM, spaceXL, spaceXS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import { CompanyImage, CompanyName } from '../../company-info';
import { Title } from '../title';

const AdditionalInfos = styled.div`
  display: flex;
  gap: ${spaceXS};
  flex-direction: column;
`;

const AdditionalInfo = styled(BodyCopy)`
  ${lineClamp(1)}
`;

const CompanyInfo = styled.div`
  display: flex;
  gap: ${spaceM};
  margin-bottom: ${spaceXL};

  @media ${mediaConfined} {
    margin-top: ${spaceL};
  }
`;

const SmallTitleContainer = styled(OnlyOnSmall)`
  margin-bottom: ${spaceXS};
`;

type Props = {
  title?: string;
  company?: CompanyData;
  industry?: string;
  location?: string;
};

const trackingParams = 'sc_o=jobs_header_company_logo_name_click';

export const JobIntro: React.FC<Props> = ({
  title,
  company,
  industry,
  location,
}) => {
  if (!company) {
    return null;
  }

  return (
    <>
      <NotOnSmall>
        <Title title={title} />
      </NotOnSmall>
      <CompanyInfo>
        <CompanyImage
          logo={company.logo}
          link={company.link}
          trackingParams={trackingParams}
        />
        <AdditionalInfos>
          <SmallTitleContainer>
            <Title title={title} />
          </SmallTitleContainer>
          <CompanyName
            name={company.name}
            link={company.link}
            trackingParams={trackingParams}
          />
          <NotOnSmall>
            <AdditionalInfo noMargin>{industry}</AdditionalInfo>
          </NotOnSmall>
          <AdditionalInfo noMargin>{location}</AdditionalInfo>
        </AdditionalInfos>
      </CompanyInfo>
    </>
  );
};
